import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useListMcpToolLabelsQuery } from '../api/mcpApi';

const ToolDisplayNamesContext = createContext<ReadonlyMap<string, string>>(
  new Map()
);

export function McpToolDisplayNamesProvider({
  children
}: {
  children: ReactNode;
}) {
  const { data } = useListMcpToolLabelsQuery();
  const map = useMemo(() => {
    const next = new Map<string, string>();
    for (const row of data?.items ?? []) {
      const name = row.name?.trim();
      const title = row.title?.trim();
      if (name && title) next.set(name, title);
    }
    return next;
  }, [data?.items]);

  return (
    <ToolDisplayNamesContext.Provider value={map}>
      {children}
    </ToolDisplayNamesContext.Provider>
  );
}

export function useMcpToolDisplayTitle(toolName: string): string {
  const map = useContext(ToolDisplayNamesContext);
  return map.get(toolName) ?? toolName;
}
